import { DocumentReference, DocumentData } from "@angular/fire/firestore";
import { MenuItemData } from "./menu-item.model";

export class MenuSummary {
  public items: MenuItemData[];
  public tipOptions: string[];
  public tipRecipient: string;
  constructor(data: DocumentData) {
    this.tipOptions = data.tipOptions ?? null;
    this.tipRecipient = data.tipRecipient ?? null;
    this.items = data.items.map((item: DocumentData) => new MenuItemData(item));
  }
}
